module.exports = __webpack_public_path__ + "static/media/sofa.229fcdf4.svg";